<template>
  <content-container title="平台用户" :table-row-count="tableData.length">
    <!-- 非搜索区域的额外按钮 -->
    <div>
      <el-button v-permission="[`${systemPermission}:dept:add`]" type="primary" class="mb-[20px]" @click="hanldeManage('add')">
        新增
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table v-loading="loading" default-expand-all row-key="id" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData">
      <el-table-column align="left" prop="deptName" label="部门" show-overflow-tooltip :min-width="120" />
      <el-table-column
        align="center"
        prop="actions"
        fixed="right"
        width="120"
        label="操作"
      >
        <template #default="scope">
          <template v-if="scope.row?.deptLevel !== 0">
            <el-button v-permission="[`${systemPermission}:dept:edit`]" link type="primary" @click="hanldeManage('edit', scope.row)">
              编辑
            </el-button>
            <el-button v-permission="[`${systemPermission}:dept:delete`]" link type="primary" @click="hanldeDelete(scope.row)">
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/修改部门 -->
    <manage-department 
      :visible="showManageDepartment" 
      :open-type="openType"
      :row="currentRow"
      @close="showManageDepartment = false"
      @success="fetchData"
    />

    <!-- 删除部门 -->
    <department-delete
      :visible="showDepartmentDelete" 
      :row="currentRow"
      @close="showDepartmentDelete = false"
      @success="fetchData"
    />
  </content-container>
</template>

<script setup lang="ts">
import ManageDepartment from './dialogs/ManageDepartment.vue';
import DepartmentDelete from './dialogs/DepartmentDelete.vue';
import { computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import {
  ContentContainer,
  queryDeptTreeList,
  useUserStore,
} from '@core/main';
import { IDeptTreeItem } from '@core/main/types';
import { ESystemType } from '@core/api';

defineOptions({ name: 'DepartmentManage' }); // 系统设置 - 部门管理

const { state: userState } = useUserStore();

const loading = ref(false);
const openType = ref<'edit' | 'add'>('add');
const showManageDepartment = ref(false);
const showDepartmentDelete = ref(false);
const tableData = ref<IDeptTreeItem[]>([]);
const currentRow = ref<IDeptTreeItem>();

const systemType = computed(() => userState?.identity?.systemType as ESystemType);
const systemPermission = computed(() => systemType.value === ESystemType.SAAS ? 'saas' : systemType.value === ESystemType.Agent ? 'agent' : systemType.value === ESystemType.Company ? 'company' : 'server');

async function fetchData() {
  loading.value = true;

  try {
    tableData.value = await queryDeptTreeList() || [];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function hanldeManage(type, row?: IDeptTreeItem) {
  openType.value = type;
  currentRow.value = type === 'add' ? undefined : row;
  showManageDepartment.value = true;
}

function hanldeDelete(row: IDeptTreeItem) {
  currentRow.value = row;
  showDepartmentDelete.value = true;
}

function init() {
  fetchData();
}

init();

</script>
